import { actionTypes } from '../types'
import SnackbarState from '../types/SnackbarState'

const snackbarActions = () => {
  const setSnackbarState = (snackbarState: SnackbarState): actionTypes => ({
    type: 'setSnackbarState',
    payload: snackbarState
  })

  return {
    setSnackbarState
  }
}

export default snackbarActions
